import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const sendNewsletterSubmissionSuccessEvent = async (email: string) => {
  await sendGAEvent({
    event: 'custom_event',
    event_action: 'Newsletter opt in',
    event_category: 'Footer',
    event_label: 'success',
    user_email: email,
  });
};

export const sendNewsletterSubmissionErrorEvent = (error: string) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Newsletter opt in error',
    event_category: 'Footer',
    event_label: error,
  });
};
